/**
 * LoadingSpinner - Componente de carga con el isologo de Seguros Horizonte
 */

export const LoadingSpinner = ({ size = 'md', text = 'Cargando...' }) => {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-14 h-14',
    lg: 'w-20 h-20',
    xl: 'w-28 h-28'
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="relative">
        <div className={`${sizes[size]} animate-pulse`}>
          <img 
            src="/isologo-azul.png" 
            alt="Seguros Horizonte" 
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      {text && (
        <p className={`${textSizes[size]} text-muted-foreground font-medium`}>
          {text}
        </p>
      )}
    </div>
  );
};

/**
 * FullPageLoader - Loader a pantalla completa con isologo
 */
export const FullPageLoader = ({ text = 'Cargando...' }) => {
  return (
    <div className="fixed inset-0 bg-[#001a3a] flex flex-col items-center justify-center z-50">
      <div className="animate-fade-in flex flex-col items-center gap-5">
        <img 
          src="/isologo-blanco.png" 
          alt="Seguros Horizonte" 
          className="w-20 h-20 object-contain"
          style={{ animation: 'logoPulse 2s ease-in-out infinite' }}
        />
        <p className="text-white/70 text-sm font-medium">{text}</p>
        <div className="w-32 h-1 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#279ddc] to-[#09d7d7] rounded-full"
            style={{ animation: 'loadBar 1.5s ease-in-out infinite' }} />
        </div>
      </div>
      <style>{`
        @keyframes logoPulse {
          0%, 100% { opacity: 0.8; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.05); }
        }
        @keyframes loadBar {
          0% { width: 0%; margin-left: 0; }
          50% { width: 60%; margin-left: 20%; }
          100% { width: 0%; margin-left: 100%; }
        }
      `}</style>
    </div>
  );
};
